import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCookieConsent } from "@/lib/cookie-consent";
import {
  disableGoogleAnalytics,
  loadGoogleAnalytics,
  trackPageView,
} from "@/lib/google-analytics";

export function GoogleAnalytics() {
  const { analytics } = useCookieConsent();
  const location = useLocation();

  useEffect(() => {
    if (!analytics) {
      disableGoogleAnalytics();
      return;
    }

    loadGoogleAnalytics();
    trackPageView(`${location.pathname}${location.search}${location.hash}`);
  }, [analytics, location.hash, location.pathname, location.search]);

  return null;
}
